import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { SeatIcon } from "@/components/shop/SeatIcon";
import { useAuth } from "@/lib/auth";
import { errMsg } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  const input = "w-full h-11 px-3 bg-[#1F2230] border border-[#3B4157] text-sm outline-none focus:border-orange-500";

  return (
    <div className="min-h-screen grid place-items-center bg-[#1F2230] grid-lines px-4">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm border border-[#3B4157] bg-[#292D3C] p-8 rise">
        <div className="hazard h-1 -mx-8 -mt-8 mb-8" />
        <div className="flex items-center gap-2">
          <span className="grid place-items-center w-9 h-9 bg-orange-500 text-[#1F2230]"><SeatIcon className="w-5 h-5" /></span>
          <span className="font-display font-black text-xl uppercase">Admin</span>
        </div>
        <div className="space-y-4 mt-8">
          <input data-testid="login-email-input" type="email" placeholder="El. paštas" value={email} onChange={(e) => setEmail(e.target.value)} className={input} required />
          <input data-testid="login-password-input" type="password" placeholder="Slaptažodis" value={password} onChange={(e) => setPassword(e.target.value)} className={input} required />
          {err && <p data-testid="login-error" className="text-sm text-red-400">{err}</p>}
          <button data-testid="login-submit-button" disabled={busy} className="w-full h-11 bg-orange-500 text-[#1F2230] font-display font-bold uppercase tracking-widest hover:bg-orange-400 disabled:opacity-60 inline-flex items-center justify-center gap-2">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Prisijungti
          </button>
        </div>
      </form>
    </div>
  );
}
